<template>
    <div class="page-container" v-show="enabled">
        <div class="timeline-text-container animate__animated animate__slideInUp">
        <div class="timeline-text-header">
            <div class="timeline-text-title">
                <h5>{{ title }}</h5>
                <p>{{ subTitle }}</p>
            </div>
            <div class="timeline-text-button">
                <img src="@/assets/close.png" @click="disable()">
            </div>
        </div>
        <div class="timeline-text-box">
            <p>{{ mainText }}</p>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    props: ['enabled', 'mainText', 'title', 'subTitle'],
    methods: {
        disable() {
            const self = this
            self.$emit('disableInfoBox')
        }
    }
}
</script>
<style scoped>
.page-container {
    position: absolute;
    top: 0;
    width: 100vw;
    height: 100dvh;
}
.timeline-text-container {
    width: 25%;
    height: 60%;
    position: absolute;
    top: 18%;
    left: 37%;
    padding: 1em 2em;
    border-radius: 5px;
    overflow: scroll;
    border: 1px solid;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    background: rgba(255, 255, 255, 1);
    animation: slideInUp;
    animation-duration: .25s !important;
    animation-timing-function: linear !important;
}

.timeline-text-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.timeline-text-title h5 {
    font-size: 2em;
    font-family: 'Castoro', serif;
    margin: 0;
}

.timeline-text-title p {
    font-size: 1.2em;
    font-family: 'Inter', sans-serif;
    margin: 0;
    display: inline-block;
    border-bottom: 1px dotted;
}

.timeline-text-button {
    display: flex;
    align-items: center;
    justify-content: center;
}

.timeline-text-button img {
    width: 50%;
    cursor: pointer;
}


.timeline-text-box p {
    font-family: 'Inter', sans-serif;
    font-size: 1em;
    line-height: 1.7;
    opacity: .8;
}

@media screen and (max-width: 1500px) {
    .page-container {
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 0 1em;
    }

    .timeline-text-container {
        width: 100%;
        position: static;
    }
}
</style>